<script>
	export default {
		name: 'InitExecuter',
		methods: {
			getInitsInfoVal(inits, key) {
				const self_ = this;
				return self_.$_initExec_getInitVal(inits, 'info', key)
			},
			getInitsLangVal(inits, key) {
				const self_ = this;
				return self_.$_initExec_getInitVal(inits, 'lang', key)
			},
			getInitsLinkVal(inits, key) {
				const self_ = this;
				return self_.$_initExec_getInitVal(inits, 'link', key)
			},
			getInitsStyleVal(inits, key) {
				const self_ = this;
				return self_.$_initExec_getInitVal(inits, 'style', key)
			},
			$_initExec_getInitVal(inits, type, key) {
				const self_ = this;
				if(self_.isEmpty(inits) || self_.isFalse(key)) { return null }
				return inits[type][key]
			}
		}
	}
</script>